'use strict';
angular.module("Login", ['ngCookies', 'ngRoute', 'base64', 'ui.bootstrap']);

angular.module("Login").config(function ($routeProvider, $locationProvider) {
    $routeProvider
        .when(
        '/auth/forgot-password', {
            templateUrl: '/auth/templates/forgot-password.html',
            controller: 'ForgotController'
        }).when(
        '/auth/:changed?', {
            templateUrl: '/auth/templates/login.html',
            controller: 'LoginController',
        }).when(
        '/auth/reset-password/:token', {
            templateUrl: '/auth/templates/reset-password.html',
            controller: 'ResetController'
        }).otherwise("/auth");

        $locationProvider.html5Mode({
                enabled: true,
                requireBase: false
            })
});



//////////////////
// WEBPACK FOOTER
// ./auth/js/auth.js
// module id = 143
// module chunks = 0